import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import Lottie from 'lottie-web';
import { switchMap } from 'rxjs/operators';
import { SessionService } from '../../../core/services/session.service';
import { CustomerService } from '../../../modules/customer-zone/services/customer-service.service';
import { UserSurveyService } from '../../../modules/survey/services/user-survey.service';
import { BlockedScreenElements } from '../../../shared/models/BlockedScreenElements';
import { HelperService } from '../../../shared/services/helper.service';
import { ProductCodeRange } from '../../models/LeadProducts';
import { SessionKeys } from '../../models/SessionKeys';
import { BlockedContextService } from '../../services/blocked-page-constant.service';
import { RouteNames } from '../../routing/app-routing.constants';
import { AgTranslateService } from '@ag/vc.ag-core/translate';
import { SurveySessionWindow } from '../../models/SurveyModel';
import { UserAuthenticationService } from '../../../modules/authentication/services/user-authentication.service';
import { EligibilityReason, IsSubscriptionAllowedReqObj, IsSubscriptionAllowedResponse } from '../../models/PersonAndPreferences';
import { SurveyFlow } from 'src/app/core/models/context';

@Component({
  selector: 'app-blocked',
  templateUrl: './blocked.component.html',
  styleUrls: ['./blocked.component.scss']
})
export class GlobalBlockedComponent implements OnInit, AfterViewInit {
  asset = './assets/unauthorized-user-blocked.json';
  screenLabels : BlockedScreenElements;
  currentBlockedContext: string;
  dynamicField_firstPara: string;
  dynamicField_secondPara: string;
  dynamicField_PrimaryBtnText: string;
  dynamicField_SecondaryBtnText: string;

  firstName:string;
  callbackUrlFr: string;
  callbackUrlNl: string;
  isIncorrectPartner: boolean;
  partnerName: string;
  customImgCss: string;
  isImageLarge: true;
  isImageFullWidth: boolean;
  PrimaryBtnHidden: boolean;
  RouteNames = RouteNames;

  constructor(
    private readonly session: SessionService,
    private readonly helperService: HelperService,
    private readonly route: ActivatedRoute,
    private readonly blockedService : BlockedContextService,
    private readonly customerService: CustomerService,
    private readonly router: Router,
    private readonly userSurveyService: UserSurveyService,
    private readonly translateService: AgTranslateService,
    private readonly userAuth: UserAuthenticationService
  ) { }

  ngOnInit(): void {
    this.session.setHelpWidgetSubject(false);
    this.route.paramMap.subscribe(params => {
      if(params.get('blockedContext')){
        this.currentBlockedContext = params.get('blockedContext');
        this.screenLabels = this.blockedService.BLOCKED_PAGE_CONSTANT[this.currentBlockedContext] as BlockedScreenElements;
        this.PrimaryBtnHidden = (this.screenLabels?.isPrimaryButtonVisible  === false) ? true : false;
        this.dynamicField_firstPara = this.blockedService.getFirstParaDynamicField();
        if(this.currentBlockedContext === RouteNames.SimulationBlocked || this.currentBlockedContext === RouteNames.ExistingContractBlocked){
          if (!this.dynamicField_firstPara){
            this.dynamicField_firstPara = this.customerService.getCustomerDetails().PersonFirstName;
          }
        }
        if (this.currentBlockedContext === RouteNames.BlockedAge) {
          // if (this.session.getUserParams().partnercodeRange === ProductCodeRange.Uppie) {
            this.screenLabels.tipTitle = 'BlockedScreen.Blocked-Age-Uppie.OverTitle';
            this.screenLabels.title = 'BlockedScreen.Blocked-Age-Uppie.Title';
            this.screenLabels.desc = 'BlockedScreen.Blocked-Age-Uppie.Block-Text';
            this.screenLabels.ctaText = 'BlockedScreen.Blocked-Age-Uppie.Button-text';
            this.screenLabels.adobeStepName = 'Blocked user age';
            this.screenLabels.adobeSubmittrigger = 'ab.blocked-user-age';
          // }
        }
        if (this.currentBlockedContext === RouteNames.BlockedCountry) {
          // if (this.session.getUserParams().partnercodeRange === ProductCodeRange.Uppie) {
            this.screenLabels.tipTitle = 'BlockedScreen.Blocked-Country-Uppie.OverTitle';
            this.screenLabels.title = 'BlockedScreen.Blocked-Country-Uppie.Title';
            this.screenLabels.desc = 'BlockedScreen.Blocked-Country-Uppie.Block-Text';
            this.screenLabels.ctaText = 'BlockedScreen.Blocked-Country-Uppie.Button-text';
            this.screenLabels.adobeStepName = 'Blocked user residence';
            this.screenLabels.adobeSubmittrigger = 'ab.blocked-user-residence';
          // }
        }
      }
    });
    this.route.queryParams.subscribe(params => {
      if (this.currentBlockedContext === RouteNames.InvalidTokenUppie || this.currentBlockedContext === RouteNames.InvalidTokenZennie){
        this.callbackUrlFr = this.returnWithHttp(params.callback_FR as string);
        this.callbackUrlNl = this.returnWithHttp(params.callback_NL as string);
        this.partnerName = (params.partner as string)?.toString().toLowerCase().charAt(0).toUpperCase() + (params.partner as string)?.toString().toLowerCase().substring(1);
        this.dynamicField_firstPara = this.dynamicField_secondPara = this.dynamicField_PrimaryBtnText = this.partnerName;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-assignment
        this.isIncorrectPartner = params.invalid ? JSON.parse(params.invalid) : false;
      }
    });
  }

  ngAfterViewInit(): void {
    if (this.screenLabels.imageUrl.includes('json')){
      const svgContainer = document.getElementById('jsonImageIcon');
      Lottie.loadAnimation(this.helperService.getLottieConfig(svgContainer, false, true, 'no-product', this.screenLabels.imageUrl));
    }
  }

  nextAction(event: string): void | boolean {
    if (event === 'forward') {
      if (this.callbackUrlFr || this.callbackUrlNl){
        if (this.translateService.currentLang === 'nl'){
          window.location.href = this.callbackUrlNl;
        }else{
          window.location.href = this.callbackUrlFr;
        }
        return false;
      }
      if (this.currentBlockedContext === RouteNames.BlockedExpiredIdentification){
        this.userAuth.redirectToMSARegistrationScreen();
        return false;
      }
      if (this.currentBlockedContext === RouteNames.SimulationBlocked){
        this.helperService.clearSession(SessionKeys.EMAnswers);

        const data: IsSubscriptionAllowedReqObj = {
          Uci:  localStorage.uci,
          ProductRangeCd: Number(this.session.getUserParams().partnercodeRange),
        }
        this.customerService.checkIsSubscriptionAllowed(data).subscribe({
          next: (res: IsSubscriptionAllowedResponse) => {
            this.customerService.setSubscriptionAllowedReason = res as IsSubscriptionAllowedResponse;
            const status = res.IneligibilityReason;
            if ((status !== EligibilityReason.NissExpired) && (status !== EligibilityReason.NissExpiryMissing)){
              void this.router.navigate(['/' + RouteNames.customerZone + '/' + RouteNames.customerHome]);
            }else{
              void this.router.navigate([`${RouteNames.blocked}/${RouteNames.BlockedExpiredIdentification}`]);
            } 
          }, error: () => {
            this.helperService.showGenericErrorToast();
          }         
        }); 
        
        return false;
      }
      if (this.currentBlockedContext === RouteNames.ExistingContractBlocked){
        void this.router.navigate(['/' + RouteNames.customerZone + '/' + RouteNames.customerHome]);
        return false;
      }
      if (this.currentBlockedContext === RouteNames.BlockedDueToUsedNiss || this.currentBlockedContext === RouteNames.BlockedUnmatchedNiss){
        void this.router.navigate(['/' + RouteNames.authentication + '/' + RouteNames.logout]);
        return false;
      }
      if(this.currentBlockedContext == RouteNames.RedirectionScreenChild){
        window.location.href = (this.translateService.currentLang ===  'fr') ?
         this.screenLabels.ctaLinkFR : this.screenLabels.ctaLinkNL; 
         return false;
      }
      
      window.location.href = this.screenLabels.ctaLink + this.translateService.currentLang;
    }
    if (event === 'back'){
      if (this.isIncorrectPartner){
        if (this.translateService.currentLang === 'nl'){
          window.location.href = "https://www.uppie.be/nl/waar-te-vinden?utm_medium=referral&utm_source=uppie&utm_campaign=m2_blockingscreen_id-nl&utm_content=choosepartner";
        }
        else{
          window.location.href= "https://www.uppie.be/fr/ou-trouver-uppie?utm_medium=referral&utm_source=uppie&utm_campaign=m2_blockingscreen_id-fr&utm_content=choosepartner";
        }
        return false;
      }      
      if (this.currentBlockedContext === RouteNames.BlockedExpiredIdentification){
        this.userAuth.redirectToItsMeAndMSA(); // redirect to itsMe in new tab and expire the session then redirect to MSA login screen in current tab
        return false;
      }
      if (this.currentBlockedContext === RouteNames.SimulationBlocked){
        if (this.helperService.getSessionValue(SessionKeys.startSurveyKey)) {
          const surveyWindow = JSON.parse(this.helperService.getSessionValue(SessionKeys.startSurveyKey)) as SurveySessionWindow;
          const currentTimeStamp = new Date().getTime();
          if (currentTimeStamp - surveyWindow?.timeStamp < this.session.maxDurationToStartSurvey) {
  
  
  
            this.userSurveyService.getSimulation(Number(localStorage.personId)).pipe(
              switchMap(res => {
                this.customerService.setPendingSurvey(res);
                const ZennieSimulationToBeDeleted = res.find(x => x.ProductRange === ProductCodeRange.Zennie);
                return this.userSurveyService.deleteSurvey(ZennieSimulationToBeDeleted.SimulationId);
              })
            ).subscribe(res => {
              if (res){
                // if (this.sessionService.getUserParams()?.partnercode) { // creating a simulation only if partner code is there
                this.customerService.createNewSimulation(Number(localStorage.personId), this.session.getUserParams().partnercodeRange).subscribe(res => {
                  this.helperService.clearSession(SessionKeys.startSurveyKey); // removing the session variable for starting simulation
                  this.customerService.setPendingSurvey(res);
                  const newZennieQuote = res.find(x=> x.ProductRange === ProductCodeRange.Zennie);
                  sessionStorage.userSurvey = btoa(JSON.stringify({
                    surveyId: newZennieQuote.Survey,
                    simulationId: newZennieQuote.SimulationId,
                    startingStep: newZennieQuote.SectionId,
                    partnerId: newZennieQuote.PartnershipId,
                    surveyCode: newZennieQuote.Survey,
                    partnerCodeRange: newZennieQuote.ProductRange
                  }));
                  this.customerService.startSimulation(SurveyFlow.CreateQuote);                
                });
              }
            });
          }else {
            void this.router.navigate(['/' + RouteNames.customerZone + '/' + RouteNames.customerHome]);
          }
        }
      }
      if( this.currentBlockedContext === RouteNames.InvalidTokenUppie){
        window.location.href = this.screenLabels.secondaryCtaLink + this.translateService.currentLang;
      }
      if( this.currentBlockedContext === RouteNames.InvalidTokenZennie){
        window.location.href = this.screenLabels.secondaryCtaLink + this.translateService.currentLang;
      }
    }
  }

  returnWithHttp(url: string): string{
    if (!url){
      return '';
    }
    if (!url.startsWith('http')){
      return `https://${url}`;
    }else{
      return url;
    }
  }
  getSubmitTrigger(): string {
    if (this.screenLabels.adobeSubmittrigger) {
      return 'button.' + this.screenLabels.adobeSubmittrigger;
    }
    return '';
  }

  handleNavigation(): void {
    this.userAuth.redirectToItsMeAndMSA();
  }
}

